import { defineStore } from "pinia";
import { ref } from "vue";
import axios from "axios";

export const useAddressStore = defineStore("addresses", () => {
  const addresses = ref([]);
  const meta = ref(null);
  const isLoading = ref(false);

  const fetchAddresses = async (page = 1, searchParams = {}) => {
    if (isLoading.value) return;

    isLoading.value = true;

    try {
      const params = { page, ...searchParams };
      const response = await axios.get("/api/addresses", { params });

      addresses.value = response.data.data;
      meta.value = response.data.meta;
      return response.data.data;
    } finally {
      isLoading.value = false;
    }
  };

  const fetchAddressById = async (id) => {
    isLoading.value = true;

    try {
      const response = await axios.get(`/api/addresses/${id}`);
      return response.data.data;
    } finally {
      isLoading.value = false;
    }
  };

  const addAddress = async (addressData) => {
    if (isLoading.value) return;

    isLoading.value = true;

    try {
      const response = await axios.post("/api/addresses", addressData);
      addresses.value.push(response.data.data);
      return response.data.data;
    } finally {
      isLoading.value = false;
    }
  };

  const updateAddress = async (id, addressData) => {
    if (isLoading.value) return;

    isLoading.value = true;

    try {
      const response = await axios.put(`/api/addresses/${id}`, addressData);
      const index = addresses.value.findIndex((address) => address.id === id);
      if (index !== -1) {
        addresses.value[index] = response.data.data;
      }
      return response.data.data;
    } finally {
      isLoading.value = false;
    }
  };

  const deleteAddress = async (id) => {
    if (isLoading.value) return;

    isLoading.value = true;

    try {
      await axios.delete(`/api/addresses/${id}`);
      addresses.value = addresses.value.filter((address) => address.id !== id);
      return true;
    } finally {
      isLoading.value = false;
    }
  };

  return {
    addresses,
    meta,
    isLoading,
    fetchAddresses,
    fetchAddressById,
    addAddress,
    updateAddress,
    deleteAddress,
  };
});
